import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class DDAIService {

  public toggleDDAI$: Subject<void> = new Subject<void>();
  public DDAICookie: string;

  constructor(
    private as: AuthService,
    private http: HttpClient,
    private cs: CommonService,
  ) {
    this.DDAICookie = this.cs.readCookie('dd-ai-cookie');
  }
  

  public updateElementHeight() {
    let height = $('.navigationbar').outerHeight() +
        ($('#siteBanner').outerHeight() ? $('#siteBanner').outerHeight() : 0) +
        ($('#emergencyBanner').outerHeight() ? $('#emergencyBanner').outerHeight() : 0) +
        ($('#cookiePolicyBanner').outerHeight() ? $('#cookiePolicyBanner').outerHeight() : 0);
    document.documentElement.style.setProperty('--jquery-element-height', height + 'px');
    document.documentElement.style.setProperty('--dd-ai-height', $('#ddai').outerHeight() + 'px');
  }

  public initDDAIBotScript(): Observable<any> {
      return this.http.get(`https://ddai.dickerdata.online/embeddedsession?token=${this.DDAICookie}`)
          .pipe(catchError(this.as.handleError));
  }
}
